import { Navigate, Route, Routes } from 'react-router-dom';

import './App.scss';
import Layout from './components/Layout/Layout';
import Complete from './pages/Complete/Complete';
import Home from './pages/Home/Home';
import InviteTeammates from './pages/InviteTeammates/InviteTeammates';
import NotFound from './pages/NotFound/NotFound';
import Payment from './pages/Payment/Payment';
import PricingPlans from './pages/PricingPlans/PricingPlans';
import SignIn from './pages/SignIn/SignIn';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/signin" element={<SignIn />}></Route>
        <Route path="/oauth/complete" element={<Complete />}></Route>
        <Route path="/plans" element={<PricingPlans />}></Route>
        <Route path="/payment" element={<Payment />}></Route>
        <Route path="/invite-teammates" element={<InviteTeammates />}></Route>

        <Route path="/not-found" element={<NotFound />}></Route>
        <Route path="/*" element={<Navigate to="/not-found" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
